import { createSelector, createStructuredSelector } from "reselect";
import {
  selectDirectLoginEnabled,
  selectUserInfo,
  selectUserName,
  selectHasUserAcceptedTnC,
  selectTnCForCidpUser,
} from "scenes/selectors";
import { State as EnvAuthenticatorState, initialState } from "./redux";

/**
 * Direct selector to the envAuthenticator state domain
 */

const selectEnvAuthenticatorDomain: (any) => EnvAuthenticatorState = (state) =>
  state.envAuthenticator || initialState;

/**
 * Custom selectors to the envAuthenticator state
 */
export const selectEnvAuthenticator = createSelector(
  selectEnvAuthenticatorDomain,
  (substate) => substate
);

export const currentFlow = createSelector(
  selectEnvAuthenticator,
  (subState) => subState.currentFlow
);

export const selectQrCode = createSelector(
  selectEnvAuthenticatorDomain,
  (substate) => substate.qrCodeImg
);

export const selectQrLinkSubmission = createSelector(
  selectEnvAuthenticatorDomain,
  (substate) => substate.loadingPasscodeSubmission
);

export const selectError = createSelector(
  selectEnvAuthenticatorDomain,
  (substate) => substate.showError
);

export const selectStatus = createSelector(
  selectEnvAuthenticatorDomain,
  (substate) => substate.status
);

export const selectSecretCode = createSelector(
  selectEnvAuthenticatorDomain,
  (substate) => substate.secretCode
);

/**
 * Multi instance selectors exporting a factory
 */
export const makeSelectEnvAuthenticator = () =>
  createSelector(selectEnvAuthenticatorDomain, (substate) => substate);

// add structured selectors here, which will be mapped as prop to scene component
export default createStructuredSelector({
  qrCodeImg: selectQrCode,
  loadingPasscodeSubmission: selectQrLinkSubmission,
  showError: selectError,
  status: selectStatus,
  secretCode: selectSecretCode,
  username: selectUserName,
  currentFlow,
  userInfo: selectUserInfo,
  isDirectLoginEnabled: selectDirectLoginEnabled,
  updatedTnC: selectTnCForCidpUser,
  hasUpdatedTnCAccepted: selectHasUserAcceptedTnC,
  tncForCidpUser: selectTnCForCidpUser,
});
